import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { Newsletter } from "~/features/newsletter";
import { takeFirst } from "~/features/app/utils";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type NewsletterBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  headline?: string | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function NewsletterBlockView({
  anchor,
  hasTopDivider = true,
  headline,
  mode = "light",
  sectionProps,
  theme = "white"
}: NewsletterBlockViewProps) {
  const themeStyle = getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  return <_StyledSection {...sectionProps} data-theme={mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "backgroundColor": "var(--bg-secondary)",
    "padding": "var(--spacing-xl)"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css2={[{
        "borderRadius": "4px",
        "backgroundColor": "var(--bg-secondary)"
      }]}>
          <_StyledDiv2 $_css3={[{
          "paddingLeft": "1.6rem",
          "paddingRight": "1.6rem",
          "@media (min-width: 1024px)": {
            "paddingLeft": "0",
            "paddingRight": "0"
          }
        }]}>
            <_StyledDiv3>
              <Newsletter size="large" text={headline ?? undefined} />
            </_StyledDiv3>
          </_StyledDiv2>
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-117krz-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-117krz-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-117krz-2"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-117krz-3"
})`${p => p.$_css3}`;
var _StyledDiv3 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "newsletter___StyledDiv3",
  componentId: "sc-1kbj1of-0"
})({
  "position": "relative",
  "zIndex": "10",
  "backgroundColor": "var(--bg-tertiary)",
  "paddingLeft": "var(--spacing-md)",
  "paddingRight": "var(--spacing-md)",
  "paddingTop": "var(--spacing-xl)",
  "paddingBottom": "var(--spacing-xl)",
  "@media (min-width: 1024px)": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "space-between",
    "columnGap": "var(--spacing-xl)",
    "padding": "var(--spacing-3xl)"
  }
});